// NovelGen API服务 - 使用新的接口
import { parseResponseContent } from './response-parser'
import { BaseAIService, GenerateRequest, GenerateResponse, StreamResponse } from './base-ai-service'
// import { encryptToken } from './encrypt-token'

interface NovelGenConfig {
  // 暂时不需要apiKey，使用encryptToken()
}

class NovelGenService extends BaseAIService {
  private config: NovelGenConfig

  constructor(config: NovelGenConfig = {}) {
    super()
    this.config = config
  }



  // 流式生成响应 - 使用新的NovelGen API
  async *generateStreamResponse(request: GenerateRequest): AsyncGenerator<StreamResponse, void, unknown> {
    const prompt = this.buildPrompt(request)
    const { content } = request
    
    try {
      const controller = new AbortController()
      
      const response = await fetch('https://ctwserver.xyz/apif/novelgen', {
        method: 'POST',
        credentials: 'include',
        signal: controller.signal,
        headers: {
          'Content-Type': 'application/json',
          //'Origin': 'http://localhost:3000', // 添加 Origin 头
          'Origin': 'https://communicate2win.com', // 添加 Origin 头
        },
        body: JSON.stringify({
          title: content,
          content: prompt
        })
      })

      // 基本错误处理
      if (!response.ok || !response.body) {
        throw new Error(`HTTP Error ${response.status}`)
      }

      const reader = response.body.getReader()
      const decoder = new TextDecoder()
      let buf = ''
      let fullContent = ''

      try {
        while (true) {
          const { value, done } = await reader.read()
          if (done) break

          buf += decoder.decode(value, { stream: true })

          // 以 "\n\n" 为分隔，一次可能拿到多条，也可能半条
          let idx
          while ((idx = buf.indexOf('\n\n')) !== -1) {
            const raw = buf.slice(0, idx).trim()
            buf = buf.slice(idx + 2)

            // 只取以 "data:" 开头的行
            if (!raw.startsWith('data:')) continue
            const jsonStr = raw.replace(/^data:\s*/, '')

            try {
              const data = JSON.parse(jsonStr)
              // 后端打包的 {content: "..."}
              if (data.content) {
                fullContent += data.content
                yield {
                  content: fullContent,
                  isComplete: false,
                  detectedLanguage: request.contentLanguage || this.detectLanguage(request.content),
                  originalResponse: fullContent
                }
              }
            } catch (e) {
              console.warn('JSON parse error', e, jsonStr)
            }
          }
        }

        // 处理尾字符（大多时候为空）
        if (buf.trim()) {
          fullContent += buf.trim()
        }

        // 流式响应结束，使用统一的解析函数分离主回复和翻译
        const { response: mainResponse, translation } = parseResponseContent(fullContent)
        
        yield {
          content: fullContent,
          isComplete: true,
          translation: translation || undefined,
          detectedLanguage: request.contentLanguage || this.detectLanguage(request.content),
          originalResponse: fullContent
        }

      } finally {
        reader.releaseLock()
      }

    } catch (error) {
      console.error('NovelGen API stream call failed:', error)
      throw error
    }
  }

  // 调用API (非流式，保留向后兼容)
  async generateResponse(request: GenerateRequest): Promise<GenerateResponse> {
    const prompt = this.buildPrompt(request)
    const { content } = request
    
    try {
      const controller = new AbortController()
      
      const response = await fetch('https://ctwserver.xyz/apif/novelgen', {
        method: 'POST',
        credentials: 'include',
        signal: controller.signal,  
        headers: {
          'Content-Type': 'application/json',
          //'Origin': 'http://localhost:3000', // 添加 Origin 头
          'Origin': 'https://communicate2win.com', // 添加 Origin 头
        },
        body: JSON.stringify({
          title: content,
          content: prompt
        })
      })

      // 基本错误处理
      if (!response.ok || !response.body) {
        throw new Error(`HTTP Error ${response.status}`)
      }

      const reader = response.body.getReader()
      const decoder = new TextDecoder()
      let buf = ''
      let fullContent = ''

      // 读取完整响应
      while (true) {
        const { value, done } = await reader.read()
        if (done) break

        buf += decoder.decode(value, { stream: true })

        let idx
        while ((idx = buf.indexOf('\n\n')) !== -1) {
          const raw = buf.slice(0, idx).trim()
          buf = buf.slice(idx + 2)

          if (!raw.startsWith('data:')) continue
          const jsonStr = raw.replace(/^data:\s*/, '')

          try {
            const data = JSON.parse(jsonStr)
            if (data.content) {
              fullContent += data.content
            }
          } catch (e) {
            console.warn('JSON parse error', e, jsonStr)
          }
        }
      }

      // 处理尾字符
      if (buf.trim()) {
        fullContent += buf.trim()
      }

      if (!fullContent) {
        throw new Error('No response content received from NovelGen API')
      }

      // 使用统一的解析函数分离主回复和翻译
      const { response: mainResponse, translation } = parseResponseContent(fullContent)

      return {
        response: mainResponse,
        translation: translation || undefined,
        detectedLanguage: request.contentLanguage || this.detectLanguage(request.content)
      }

    } catch (error) {
      console.error('NovelGen API call failed:', error)
      throw error
    }
  }
}

export default NovelGenService
export type { NovelGenConfig, GenerateRequest, GenerateResponse, StreamResponse } 